import { Button } from "react-aria-components";
import IconCustomers from "../../../assets/icons/icon-customers-orange.svg"
import IconAccounts from "../../../assets/icons/icon-customers-orange.svg"
import { useNavigate } from "react-router";
import * as Navigation from "../../../modules/Navigation";
import { EntityNames } from "../../../enums/EntityNames";
import { usePermissions } from "../../../modules/auth/Permissions/PermissionContext";
import { hasPermission } from "../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../modules/auth/Permissions/PermissionStrings";

export default function EstablishmentsLandingView() {
    const navigate = useNavigate();
    const { permissions } = usePermissions();

    function handleClick(entityName: string) {
        Navigation.Establishments.navigate(navigate, entityName)
    }

    const canSeeAccounts = hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Accounts);
    const canSeeCustomers = hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Customers);

    return (<>
        <div className="grid-x grid-margin-x padding__top-bottom--s padding__left-right--l">
            {canSeeAccounts && (
                <Button className={"landing-page__button cell small-6"} onPress={() => handleClick(EntityNames.accounts)}>
                    <img alt='' src={IconAccounts} />
                    <h2 className={"landing-page__button-text"}>Accounts</h2>
                </Button>
            )}
            {canSeeCustomers && (
                <Button className={"landing-page__button cell small-6"} onPress={() => handleClick(EntityNames.customers)}>
                    <img alt='' src={IconCustomers} />
                    <h2 className={"landing-page__button-text"}>Customers</h2>
                </Button>
            )}
        </div>
    </>)
}
